<template>
    <div class="guide common-step-padding">
        <p>{{$t('guide.title')}}</p>
        <div class="step">
            <p>{{$t('guide.desps[0]')}}</p>
            <img src="../assets/images/guide1.png" alt="guide">
        </div>
        <div class="step">
            <p>{{$t('guide.desps[1]')}}</p>
            <img src="../assets/images/guide2.png" alt="guide">
        </div>
        <div class="step">
            <p>{{$t('guide.desps[2]')}}</p>
            <img src="../assets/images/guide3.png" alt="guide">
        </div>
        <div class="row no-gutters justify-content-start">
            <button type="button" class="common-comfirm-btn btn-width-100" @click="goHome">
                {{$t('guide.btnOK')}}
            </button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Guide',
    components: {

    },
    methods:{
        // 返回首页
        goHome(){
            this.$router.push({path:'/'})
        }
    }
}
</script>

<style scoped>
.guide > p{
    font-size: 34px;
    font-weight: 500;
}

.step{
    margin-top: 36px;
}

.step > p{
    font-size: 20px;
    margin-bottom: 15px;
}

.step img{
    width: 90%;
}
button{
    margin-top: 50px;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
    .guide{
        margin-top: 20px;
    }
    .guide > p{
        font-size: 20px;
    }
    .step{
        margin-top: 20px;
    }
    .step > p{
        font-size: 16px;
    }
}
</style>